// 物联网所有路由统一放在这
export default [{
  // 物联网终端管理
  path: 'terminalList',
  name: 'terminalList',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/terminalList');
  }
}, {
  // 物联网终端管理
  path: 'terminalMessage',
  name: 'terminalMessage',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/terminalMessage');
  }
}, {
  // 车辆终端管理
  path: 'vehicleTerminalList',
  name: 'vehicleTerminalList',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/vehicleTerminalList');
  }
}, {
  path: 'traceReplay',
  name: 'traceReplay',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/traceReplay.vue');
  }
}, {
  path: 'trackDetail',
  name: 'trackDetail',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/trackDetail.vue');
  }
}, {
  path: 'electronicFenceList',
  name: 'electronicFenceList',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/electronicFence/list.vue');
  }
}, {
  path: 'electronicFenceDetail',
  name: 'electronicFenceDetail',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/electronicFence/detail.vue');
  }
}, {
  path: 'exceptionRemind',
  name: 'exceptionRemind',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/exceptionRemind.vue');
  }
}, {
  path: 'electronicFence',
  name: 'electronicFence',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/electronicFence');
  }
}, {
  path: 'electronicFenceAdd',
  name: 'electronicFenceAdd',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunSupervise/electronicFence/add.vue');
  }
}, {
  path: 'vehicleDistributionList',
  name: 'vehicleDistributionList',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleDistribution/vehicleDistributionList/index.vue');
  }
}, {
  path: 'vehicleDistributionDetail',
  name: 'vehicleDistributionDetail',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleDistribution/vehicleDistributionList/detail.vue');
  }
}, {
  path: 'vehicleRunStatus',
  name: 'vehicleRunStatus',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleRunManage/vehicleRunStatus.vue');
  }
}, {
  path: 'vehicleDistributionMap',
  name: 'vehicleDistributionMap',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleDistribution/vehicleDistributionMap/index.vue');
  }
}, {
  path: 'vehicleAccountFixSearch',
  //
  name: 'vehicleAccountFixSearch',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/index.vue');
  }
}, {
  path: 'vehicleAccountFixSearch/edit1',
  name: 'vehicleAccountFixSearchEdit1',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/edit1.vue');
  }
}, {
  path: 'vehicleAccountFixSearch/edit',
  name: 'vehicleAccountFixSearchEdit',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/edit.vue');
  }
}, {
  path: 'vehicleAccountFixSearch/edit2',
  name: 'vehicleAccountFixSearchEdit2',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/edit2.vue');
  }
}, {
  path: 'vehicleAccountFixSearch/terminalList',
  name: 'vehicleAccountFixSearchTerminalList',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/terminalList.vue');
  }
}, {
  path: 'vehicleAccountFixSearch/import',
  //
  name: 'vehicleAccountFixSearchImport',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountFixSearch/import.vue');
  }
}, {
  path: 'vehiclePlatformCode',
  //
  name: 'vehiclePlatformCode',
  component: function component() {
    return import('@/components/vehicleNetApp/vehicleAccountManage/vehicleAccountCode/index.vue');
  }
}, {
  path: 'exceptionRemindManageAdd',
  name: 'exceptionRemindManageAdd',
  component: function component() {
    return import('@/components/vehicleNetApp/exceptionRemindManage/add.vue');
  }
}, {
  path: 'exceptionRemindManageDetail',
  name: 'exceptionRemindManageDetail',
  component: function component() {
    return import('@/components/vehicleNetApp/exceptionRemindManage/detail.vue');
  }
}, {
  path: 'exceptionRemindManage',
  name: 'exceptionRemindManage',
  component: function component() {
    return import('@/components/vehicleNetApp/exceptionRemindManage/index.vue');
  }
}, {
  // 设备交接鉴定表管理 2022-07-12 重做
  path: 'vehicleHandOverManage',
  name: 'vehicleHandOverManage',
  //component: () => import('@/components/vehicleManagement/vehicleHandOverManage/list.vue')
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/index.vue');
  }
}, {
  path: 'vehicleHandOverManage/list',
  name: 'vehicleHandOverManageList',
  //component: () => import('@/components/vehicleManagement/vehicleHandOverManage/list.vue')
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/list.vue');
  }
}, {
  path: 'vehicleHandOverManage/exitList',
  name: 'vehicleHandOverManageExitList',
  //component: () => import('@/components/vehicleManagement/vehicleHandOverManage/list.vue')
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/exitList.vue');
  }
}, {
  path: 'vehicleHandOverManage/add',
  name: 'vehicleHandOverManageAdd',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/add.vue');
  }
}, {
  path: 'vehicleHandOverManage/detail',
  name: 'vehicleHandOverManageDetail',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/detail.vue');
  }
}, {
  path: 'vehicleHandOverManage/newDetail',
  name: 'vehicleHandOverManageNewDetail',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/newDetail.vue');
  }
}, {
  path: 'vehicleHandOverManage/update',
  name: 'vehicleHandOverManageUpdate',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/update.vue');
  }
}, {
  path: 'carMaintainList',
  //车辆维护列表
  name: 'carMaintainList',
  component: function component() {
    return import('@/components/carManagement/maintainManagement/carMaintainList');
  },
  meta: {
    authe: true,
    title: "维护管理"
  }
}, {
  path: 'carMaintainDetails/:type',
  //车辆维护详情
  name: 'carMaintainDetails',
  component: function component() {
    return import('@/components/carManagement/maintainManagement/carMaintainDetails');
  },
  hidden: true,
  meta: {
    authe: true,
    title: "车辆维护详情"
  }
}, {
  path: 'carReportFormList',
  //车辆档案报表
  name: 'carReportFormList',
  component: function component() {
    return import('@/components/carManagement/carReportForm/carReportFormList');
  },
  meta: {
    authe: true
  }
}, {
  path: 'carMaintainReportFormList',
  //车辆年审报表
  name: 'carMaintainReportFormList',
  component: function component() {
    return import('@/components/carManagement/carReportForm/carMaintainReportFormList');
  },
  meta: {
    authe: true
  }
}, {
  path: 'carMaintainReportFormDetails',
  //车辆年审报表详情
  name: 'carMaintainReportFormDetails',
  component: function component() {
    return import('@/components/carManagement/carReportForm/carMaintainReportFormDetails');
  },
  meta: {
    authe: true
  }
}, {
  path: 'violationReportFormList',
  //违章报表
  name: 'violationReportFormList',
  component: function component() {
    return import('@/components/carManagement/carReportForm/violationReportFormList');
  },
  meta: {
    authe: true
  }
}, {
  path: 'carReport',
  //车辆报表
  name: 'carReport',
  component: function component() {
    return import('@/components/carManagement/carReportForm/carReport');
  },
  meta: {
    authe: true,
    title: "车辆报表"
  }
}, {
  path: 'historyCarList',
  //销户车辆列表
  name: 'historyCarList',
  component: function component() {
    return import('@/components/carManagement/violationManagement/historyCarList');
  },
  meta: {
    authe: true,
    title: "销户管理"
  }
}, {
  path: 'historyCarDetails',
  //销户车辆详情
  name: 'historyCarDetails',
  component: function component() {
    return import('@/components/carManagement/violationManagement/historyCarDetails');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: 'violationStat',
  //违章统计
  name: 'violationStat',
  component: function component() {
    return import('@/components/carManagement/violationManagement/violationStat');
  },
  meta: {
    authe: true,
    title: "违章统计"
  }
}, {
  path: 'dealViolation',
  //处理反馈页面
  name: 'dealViolation',
  component: function component() {
    return import('@/components/carManagement/violationManagement/dealViolation');
  },
  meta: {
    authe: true,
    title: "处理明细"
  }
}, {
  path: 'violationList',
  //违章信息列表
  name: 'violationList',
  component: function component() {
    return import('@/components/carManagement/violationManagement/violationList');
  },
  meta: {
    authe: true,
    title: "违章明细"
  }
}, {
  path: 'violationDetails',
  //违章详情
  name: 'violationDetails',
  component: function component() {
    return import('@/components/carManagement/violationManagement/violationDetails');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: 'violationAdd',
  //编制违章信息
  name: 'violationAdd',
  component: function component() {
    return import('@/components/carManagement/violationManagement/violationAdd');
  },
  meta: {
    authe: true
  }
}, {
  path: 'driverAdd',
  //编制驾驶员
  name: 'driverAdd',
  component: function component() {
    return import('@/components/carManagement/driverManagement/driverAdd');
  },
  meta: {
    authe: true
  }
}, {
  path: 'driverDetails',
  //驾驶员详情
  name: 'driverDetails',
  component: function component() {
    return import('@/components/carManagement/driverManagement/driverDetails');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: 'driverEdit',
  //修改司机信息
  name: 'driverEdit',
  component: function component() {
    return import('@/components/carManagement/driverManagement/driverEdit');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: 'driverList',
  //驾驶员列表
  name: 'driverList',
  component: function component() {
    return import('@/components/carManagement/driverManagement/driverList');
  },
  meta: {
    authe: true,
    title: "司机管理"
  }
}, {
  path: 'carAdd',
  //手动编制
  name: 'carAdd',
  component: function component() {
    return import('@/components/carManagement/carList/carAdd');
  },
  meta: {
    authe: true
  }
}, {
  path: 'carAddSelf',
  //自动导入
  name: 'carAddSelf',
  component: function component() {
    return import('@/components/carManagement/carList/carAddSelf');
  },
  hidden: true,
  meta: {
    authe: true,
    title: "自动导入"
  }
}, {
  path: 'carDetails',
  //车辆详情
  name: 'carDetails',
  component: function component() {
    return import('@/components/carManagement/carList/carDetails');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: 'carEdit',
  //修改设备
  name: 'carEdit',
  component: function component() {
    return import('@/components/carManagement/carList/carEdit');
  },
  hidden: true,
  meta: {
    authe: true
  }
}, {
  path: "carList",
  //设备列表
  name: "carList",
  component: function component() {
    return import('@/components/carManagement/carList/carList');
  },
  meta: {
    authe: true,
    title: "车辆档案"
  }
}];